import { apiSlice } from '@/features/api/apiSlice';

export type ApprovalStatus = 'pending' | 'approved' | 'rejected' | 'cancelled';

export type Approval = {
  id: string;
  versionId: string;
  requestedBy: string;
  approverId: string | null;
  status: ApprovalStatus;
  decidedAt: string | null;
  note: string | null;
  createdAt: string;
};

export const approvalsApi = apiSlice.injectEndpoints({
  endpoints: (b) => ({
    listApprovals: b.query<Approval[], string>({
      query: (versionId) => `/versions/${versionId}/approvals`,
      providesTags: (_r, _e, id) => [{ type: 'Approval', id }],
    }),
    requestApproval: b.mutation<
      Approval,
      { versionId: string; approverId?: string; note?: string }
    >({
      query: ({ versionId, ...body }) => ({
        url: `/versions/${versionId}/approvals`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_r, _e, { versionId }) => [{ type: 'Approval', id: versionId }],
    }),
    decideApproval: b.mutation<
      Approval,
      { versionId: string; approvalId: string; decision: 'approved' | 'rejected'; note?: string }
    >({
      query: ({ versionId, approvalId, decision, note }) => ({
        url: `/versions/${versionId}/approvals/${approvalId}/decide`,
        method: 'POST',
        body: { decision, note },
      }),
      invalidatesTags: (_r, _e, { versionId }) => [{ type: 'Approval', id: versionId }],
    }),
    cancelApproval: b.mutation<Approval, { versionId: string; approvalId: string }>({
      query: ({ versionId, approvalId }) => ({
        url: `/versions/${versionId}/approvals/${approvalId}/cancel`,
        method: 'POST',
      }),
      invalidatesTags: (_r, _e, { versionId }) => [{ type: 'Approval', id: versionId }],
    }),
  }),
});

export const {
  useListApprovalsQuery,
  useRequestApprovalMutation,
  useDecideApprovalMutation,
  useCancelApprovalMutation,
} = approvalsApi;
